import { render, staticRenderFns } from "./magazine.vue?vue&type=template&id=c2981dfa"
import script from "./magazine.vue?vue&type=script&lang=js"
export * from "./magazine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports